export default __webpack_public_path__ + "static/media/south-africa.82117871.png";